import { useCallback, useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { toast } from 'sonner';
import { isBadRequestError } from '@/core/api/badRequestError';
import { orderTaskService } from '@/entities/OrderTask/api/orderTaskService';
import { taskActionToPayRequest } from '@/entities/OrderTask/mappers';
import type { TaskActionFormValues } from '@/entities/OrderTask/model/schema';
import { getErrorMessage } from '@/shared/lib/errors';

/** Направляет выплату исполнителю по сделке. */
export const usePayForTaskSubmit = (
    taskId: number | null,
    form: UseFormReturn<TaskActionFormValues>
) => {
    const [completed, setCompleted] = useState(false);

    const onSubmit = useCallback(async (values: TaskActionFormValues) => {
        if (taskId === null || taskId <= 0) {
            form.setError('root.server', {
                type: 'server',
                message: 'Некорректный номер задания'
            });

            return;
        }

        form.clearErrors('root.server');

        try {
            await orderTaskService.pay(taskActionToPayRequest(values, taskId));
            form.reset(values);
            setCompleted(true);
            toast.success('Выплата исполнителю направлена');
        } catch (error: unknown) {
            if (isBadRequestError(error)) return;

            form.setError('root.server', {
                type: 'server',
                message: getErrorMessage(error, 'Не удалось направить выплату'),
            });
        }
    }, [form, taskId]);

    const resetCompleted = useCallback(() => setCompleted(false), []);

    return {
        onSubmit,
        completed,
        resetCompleted
    };
};
